module.exports = __webpack_public_path__ + "img/house_24.6a10ab6e.jpg";